import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getOwnerProfile } from "../../../api/owners.api"; // Assuming this API call exists
import { getVehiclesByOwner } from "../../../api/vehicle.api";
import { getScreensForOwner } from "../../../api/owners.api";
import { getRestaurantsByOwner } from "../../../api/restaurants.api";
import { baseURL } from "../../../api/api";
import AdminLayout from "../../layout/AdminLayout";
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { FiPlus } from "react-icons/fi";
import AddOwner from "./AddOwner";
import { getAllOwners } from "../../../api/owners.api";
function OwnerDataDetailsPage() {
  const { ownerId } = useParams(); // Get the ownerId from the URL
  const [ownerData, setOwnerData] = useState(null);
  const [editOwnerId, setEditOwnerId] = useState(null);
  const [ownersData, setOwnersData] = useState([]);
  const [addOwnerOpen, setAddOwnerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [restaurantsData, setRestaurantsData] = useState([]);
  const [vehiclesData, setVehiclesData] = useState([]);
  const [screensData, setScreensData] = useState([]); // Add state to store screens

  const fetchAllOwners = () => {
    setLoading(true); // Start loading before fetch
    getAllOwners()
      .then((res) => {
        setOwnersData(res?.data?.owners || []);
        console.log("owner data", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading after fetch completes
      });
  };

  useEffect(() => {
    // fetchOwnerProfile();
    fetchAllOwners();
  }, []);

  useEffect(() => {
    // Fetch the owner details
    getOwnerProfile(ownerId)
      .then((res) => {
        if (res.data.success) {
          setOwnerData(res.data.owner); // Set the owner data
          // Fetch vehicles for this owner
          return getVehiclesByOwner(ownerId);
        } else {
          console.error("Failed to fetch owner data");
          throw new Error("Failed to fetch owner data");
        }
      })
      .then((res) => {
        if (res.data.success) {
          setVehiclesData(res.data.vehicles); // Set the vehicles data
        } else {
          console.error("Failed to fetch vehicles data");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
    const fetchScreens = async () => {
      try {
        const res = await getScreensForOwner(ownerId);
        console.log("API Response:", res.data); // Log the whole response
        if (res.data.success) {
          setScreensData(res?.data?.screens);
        } else {
          console.error("Failed to fetch screen data");
        }
      } catch (error) {
        console.error("Error fetching screens:", error);
      }
    };

    fetchScreens();
  }, [ownerId]);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const res = await getRestaurantsByOwner(ownerId);
        if (res.data.success) {
          setRestaurantsData(res.data.restaurants);
        } else {
          console.error("Failed to fetch restaurant data");
        }
      } catch (error) {
        console.error("Error fetching restaurants:", error);
      }
    };

    fetchRestaurants();
  }, [ownerId]);

  return (
    <AdminLayout title="Owner Details">
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <RotatingLines
            strokeColor="black"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
          />
        </div>
      ) : !ownerData ? (
        <div className="text-center py-10">No owner data found</div>
      ) : (
        <>
          <AddOwner
            open={addOwnerOpen}
            setOpen={setAddOwnerOpen}
            fetchAllOwners={fetchAllOwners}
            editOwnerId={editOwnerId}
          />
          <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
            <button
              onClick={() => {
                setAddOwnerOpen(true);
                setEditOwnerId(ownerId);
              }}
              className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
            >
              {" "}
              <FiPlus className="text-lg text-gray-700" />
              Edit Owner
            </button>
          </div>

          <table className="bg-white mt-5 rounded-lg min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                  Owner Information
                </th>
                <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                  Bank Information
                </th>
                <th className="px-6 py-3 bg-gray-50 text-left text-lg font-medium text-gray-500 uppercase">
                  User Information
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="whitespace-nowrap py-5 pl-4 pr-3 sm:pl-0">
                  <div className="bg-gray-50 rounded-md p-4 ml-4 flex flex-col items-start justify-center">
                    <div>
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Name
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.name}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Email
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.email}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Phone
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.phone}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="pr-3 py-5 text-sm ">
                  <div className="bg-gray-50 rounded-md p-4">
                    <div>
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Account Holder
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.bankInfo?.accountHolder}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Account Number
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.bankInfo?.accountNumber}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        Bank Name
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.bankInfo?.bankName}
                      </span>
                    </div>
                  </div>
                </td>
                <td className="pr-3 py-5 text-sm ">
                  <div className="bg-gray-50 rounded-md p-4">
                    <div>
                      <h1 className="text-gray-600 font-semibold text-xl">
                        User Name
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.userId?.firstName}{" "}
                        {ownerData?.userId?.lastName}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        User Email
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.userId?.email}
                      </span>
                    </div>
                    <div className="mt-5 ">
                      <h1 className="text-gray-600 font-semibold text-xl">
                        User Role
                      </h1>
                      <span className="text-gray-400 font-semibold text-xl">
                        {ownerData?.userId?.role}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <h1 className="text-center text-4xl mt-5 mb-3">
            Vehicles dedicated to This Owner
          </h1>
          <div className="w-full py-10 px-4">
            <div className="overflow-x-auto">
              <div className="inline-block w-full py-2 align-middle">
                <table className="bg-white w-full rounded-lg divide-y divide-gray-300 shadow-md">
                  <tbody className="divide-y divide-gray-200">
                    {vehiclesData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="2"
                          className="text-center font-bold text-gray-600 text-xl my-4"
                        >
                          No vehicles found for this owner.
                        </td>
                      </tr>
                    ) : (
                      vehiclesData.map((vehicle, index) => (
                        <tr key={index}>
                          <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                            <div className="bg-gray-50 rounded-md p-4 ml-4 flex flex-col items-start justify-center shadow-sm">
                              <div className="w-full">
                                <div>
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Driver Name
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {vehicle?.driver?.user?.firstName}{" "}
                                    {vehicle?.driver?.user?.lastName}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Driver Email
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {vehicle?.driver?.user?.email}
                                  </span>
                                </div>
                                <div className="mt-5 ">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Phone
                                  </h1>
                                  <span className="text-gray-400 font-semibold text-base">
                                    {vehicle?.driver?.user?.phone}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="pr-3 py-5 text-sm">
                            <div className="bg-gray-50 rounded-md h-48 w-full shadow-sm mr-8">
                              <div className="flex items-center justify-start">
                                <div className="shrink-0">
                                  <img
                                    className="object-cover h-48 w-96 rounded-md"
                                    src={`${baseURL}/s3/images/${vehicle?.image}`}
                                    alt="vehicle img"
                                  />
                                </div>
                                <div className="ml-5 w-full py-5 pl-4 pr-3">
                                  <div className="my-1 grid grid-cols-12">
                                    <div className="col-span-6">
                                      <h1 className="text-gray-600 font-semibold text-base">
                                        Registration Number
                                      </h1>
                                    </div>
                                    <div className="col-span-6">
                                      <h1 className="text-gray-400 font-semibold text-base">
                                        {vehicle?.registrationNumber}
                                      </h1>
                                    </div>
                                  </div>
                                  <div className="my-1 grid grid-cols-12">
                                    <div className="col-span-6">
                                      <h1 className="text-gray-600 font-semibold text-base">
                                        Vehicle Brand
                                      </h1>
                                    </div>
                                    <div className="col-span-6">
                                      <h1 className="text-gray-400 font-semibold text-base">
                                        {vehicle?.brand}
                                      </h1>
                                    </div>
                                  </div>
                                  <div className="my-1 grid grid-cols-12">
                                    <div className="col-span-6">
                                      <h1 className="text-gray-600 font-semibold text-base">
                                        Vehicle Model
                                      </h1>
                                    </div>
                                    <div className="col-span-6">
                                      <h1 className="text-gray-400 font-semibold text-base">
                                        {vehicle?.model}
                                      </h1>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* screen sections  */}
          <h1 className="text-center text-4xl mt-5 mb-3">
            Screens dedicated to This Owner
          </h1>
          <div className="lg:mx-auto md:px-1 lg:px-4">
            <div className="my-5 grid grid-cols-1 sm:grid-cols-12 gap-6 lg:grid-cols-12 md:grid-cols-12">
              {screensData.length === 0 ? (
                <div className="text-center font-bold text-gray-600 text-xl my-4 col-span-12">
                  No screens for this owner.
                </div>
              ) : (
                screensData.map((screen, index) => (
                  <Link
                    to={`/screendetails/${screen._id}`}
                    key={index}
                    className="cursor-pointer lg:col-span-4 md:col-span-12 col-span-12"
                  >
                    <div
                      key={index}
                      className="col-span-12 xl:col-span-4 lg:col-span-6"
                    >
                      <div className="bg-white rounded-md p-5">
                        <div className="bg-gray-100 rounded-md">
                          <div className="p-5">
                            <div className="flex justify-between my-2">
                              <h1 className="text-gray-600 font-semibold text-base">
                                Access code
                              </h1>
                              <span className="text-gray-400 font-medium text-base">
                                {screen?.accessCodes.map((code) => code)}
                              </span>
                            </div>
                            <div className="flex justify-between my-2">
                              <h1 className="text-gray-600 font-semibold text-base">
                                Screen Model
                              </h1>
                              <span className="text-gray-400 font-medium text-base">
                                {screen?.model}
                              </span>
                            </div>
                            <div className="flex justify-between my-2">
                              <h1 className="text-gray-600 font-semibold text-base">
                                Screen Status
                              </h1>
                              <span
                                className={`px-2 py-0.5 rounded ${
                                  screen?.status === "Active"
                                    ? "bg-green-100 text-green-700"
                                    : screen?.status === "In Active"
                                    ? "bg-orange-100 text-orange-700"
                                    : screen?.status === "Under Maintenance"
                                    ? "bg-yellow-100 text-yellow-600"
                                    : screen?.status === "Retired"
                                    ? "bg-red-100 text-red-700"
                                    : "bg-gray-100 text-gray-800"
                                }  text-sm`}
                              >
                                {screen?.status}
                              </span>
                            </div>

                            <div className="my-2">
                              <h1 className="text-gray-600 font-semibold text-base">
                                Vehicle Information
                              </h1>
                            </div>
                            <div className="ml-5 w-80">
                              <div className="my-1 grid grid-cols-12 ">
                                <div className="col-span-6">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Brand
                                  </h1>
                                </div>
                                <div className="col-span-6">
                                  <h1 className="text-gray-400 font-medium text-base">
                                    {screen?.vehicle?.brand}
                                  </h1>
                                </div>
                              </div>
                              <div className="my-1 grid grid-cols-12">
                                <div className="col-span-6">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Model
                                  </h1>
                                </div>
                                <div className="col-span-6">
                                  <h1 className="text-gray-400 font-medium text-base">
                                    {screen?.vehicle?.model}
                                  </h1>
                                </div>
                              </div>
                              <div className="my-1 grid grid-cols-12">
                                <div className="col-span-6">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Type
                                  </h1>
                                </div>
                                <div className="col-span-6">
                                  <h1 className="text-gray-400 font-medium text-base">
                                    {screen?.vehicle?.type}
                                  </h1>
                                </div>
                              </div>
                              <div className="my-1 grid grid-cols-12">
                                <div className="col-span-6">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Service
                                  </h1>
                                </div>
                                <div className="col-span-6">
                                  <h1 className="text-gray-400 font-medium text-base">
                                    {screen?.vehicle?.service}
                                  </h1>
                                </div>
                              </div>
                              <div className="my-1 grid grid-cols-12">
                                <div className="col-span-6">
                                  <h1 className="text-gray-600 font-semibold text-base">
                                    Location
                                  </h1>
                                </div>
                                <div className="col-span-6">
                                  <h1 className="text-black font-medium text-base">
                                    {screen?.vehicle?.location}
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
              )}
            </div>
          </div>
          <h1 className="text-center text-4xl mt-5 mb-3">
            Restaurants dedicated to This Owner
          </h1>
          <div className="w-full py-10 px-4">
            <div className="overflow-x-auto">
              <div className="inline-block w-full py-2 align-middle">
                <table className="bg-white w-full rounded-lg divide-y divide-gray-300 shadow-md">
                  <tbody className="divide-y divide-gray-200">
                    {restaurantsData.length === 0 ? (
                      <tr>
                        <td
                          colSpan="2"
                          className="text-center font-bold text-gray-600 text-xl my-4"
                        >
                          No restaurants found for this owner.
                        </td>
                      </tr>
                    ) : (
                      restaurantsData.map((restaurant, index) => (
                        <tr key={index}>
                          <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                            <div className="bg-gray-50 rounded-md p-4 ml-4 flex flex-col items-start justify-center shadow-sm">
                              <div className="w-full">
                                <h1 className="text-gray-600 font-semibold text-base">
                                  Name
                                </h1>
                                <span className="text-gray-400 font-semibold text-base">
                                  {restaurant?.name}
                                </span>

                                <h1 className="text-gray-600 font-semibold text-base mt-5">
                                  Location
                                </h1>
                                <span className="text-gray-400 font-semibold text-base">
                                  {restaurant?.location}
                                </span>

                                <h1 className="text-gray-600 font-semibold text-base mt-5">
                                  Cuisine Type
                                </h1>
                                <span className="text-gray-400 font-semibold text-base">
                                  {restaurant?.cuisineType}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="pr-3 py-5 text-sm">
                            <div className="bg-gray-50 rounded-md h-48 w-full shadow-sm mr-8">
                              <div className="flex items-center justify-start">
                                <div className="shrink-0">
                                  <img
                                    className="object-cover h-48 w-96 rounded-md"
                                    src={`${baseURL}/s3/images/${restaurant?.images?.[0]}`}
                                    alt="restaurant img"
                                  />
                                </div>
                                <div className="ml-5 w-full py-5 pl-4 pr-3">
                                  <div className="my-1 grid grid-cols-12">
                                    <div className="col-span-6">
                                      <h1 className="text-gray-600 font-semibold text-base">
                                        Seating Capacity
                                      </h1>
                                    </div>
                                    <div className="col-span-6">
                                      <h1 className="text-gray-400 font-semibold text-base">
                                        {restaurant?.seatingCapacity}
                                      </h1>
                                    </div>
                                  </div>
                                  <div className="my-1 grid grid-cols-12">
                                    <div className="col-span-6">
                                      <h1 className="text-gray-600 font-semibold text-base">
                                        Contact
                                      </h1>
                                    </div>
                                    <div className="col-span-6">
                                      <h1 className="text-gray-400 font-semibold text-base">
                                        {restaurant?.contactInformation?.phone}
                                      </h1>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
}

export default OwnerDataDetailsPage;
